export const hpointAssets = {
  golf: {
    heroIllustration: "/images/hpoint-renewal/objects-3d/golf-reservation-hero.png",
    unreservedHeroIllustration:
      "/images/hpoint-renewal/objects-3d/golf-reservation-hero-unreserved.png",
    membershipHero: "/images/main_03.png",
    membershipResult: "/images/reservation_t_06.png",
    screenResult: "/images/reservation_t_11.png",
    roomResult: "/images/reservation_t_09.png",
  },
  fitness: {
    heroIllustration: "/images/hpoint-renewal/objects-3d/fitness-reservation-hero.png",
    treadmillHeroIllustration: "/images/hpoint-renewal/objects-3d/fitness-treadmill-hero.png",
    treadmillUnreservedHeroIllustration:
      "/images/hpoint-renewal/objects-3d/fitness-treadmill-hero-unreserved.png",
  },
  study: {
    booksHeroIllustration: "/images/hpoint-renewal/objects-3d/study-books-hero.png",
    booksUnreservedHeroIllustration:
      "/images/hpoint-renewal/objects-3d/study-books-hero-unreserved.png",
  },
  locker: {
    heroIllustration: "/images/hpoint-renewal/objects-3d/locker-hero.png",
    unreservedHeroIllustration:
      "/images/hpoint-renewal/objects-3d/locker-hero-unreserved.png",
  },
  robotCleaner: {
    windowHeroIllustration:
      "/images/hpoint-renewal/objects-3d/window-robot-cleaner-hero.png",
    windowBannerIllustration:
      "/images/hpoint-renewal/banners/window-cleaning-banner.svg",
  },
  community: {
    centerHeroIllustration:
      "/images/hpoint-renewal/community/community-center-hero-main.png",
  },
  directories: {
    golf: "/images/hpoint-renewal/golf/",
    icons: "/images/hpoint-renewal/icons/",
    objects3d: "/images/hpoint-renewal/objects-3d/",
  },
} as const;

export type HpointAssetGroup = keyof typeof hpointAssets;
